/**
 * 계정 사진 클라 전처리(spec 7절): 중앙 정사각형 크롭 후 size px 로 줄여 webp(0.85)로 인코딩, 미지원 브라우저는 jpeg.
 * 디코드 실패(깨진 파일·미지원 형식)는 Error('IMAGE_DECODE').
 */
export async function resizeImage(file: Blob, size = 512): Promise<Blob> {
  let bitmap: ImageBitmap;
  try {
    bitmap = await createImageBitmap(file);
  } catch {
    throw new Error("IMAGE_DECODE");
  }
  try {
    const side = Math.min(bitmap.width, bitmap.height);
    const sx = (bitmap.width - side) / 2;
    const sy = (bitmap.height - side) / 2;
    const canvas = document.createElement("canvas");
    canvas.width = size;
    canvas.height = size;
    const ctx = canvas.getContext("2d");
    if (!ctx) throw new Error("IMAGE_DECODE");
    ctx.drawImage(bitmap, sx, sy, side, side, 0, 0, size, size);
    const toBlob = (type: string, quality?: number) => new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, type, quality));
    // webp 미지원이면 브라우저가 png 를 돌려주거나 null — webp 가 아니면 jpeg 로 재시도
    const webp = await toBlob("image/webp", 0.85);
    if (webp && webp.type === "image/webp") return webp;
    const jpeg = await toBlob("image/jpeg", 0.85);
    if (!jpeg) throw new Error("IMAGE_DECODE");
    return jpeg;
  } finally {
    bitmap.close?.();
  }
}
